function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_621",
  "data-name": "Group 621",
  transform: "translate(-1297 -105)"
}, React.createElement("g", {
  id: "Rectangle_3847",
  "data-name": "Rectangle 3847",
  transform: "translate(1297 105)",
  fill: "#fff",
  stroke: "#949db2",
  strokeWidth: 1
}, React.createElement("rect", {
  width: 15,
  height: 2,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 14,
  height: 1,
  fill: "none"
})), React.createElement("g", {
  id: "Rectangle_3848",
  "data-name": "Rectangle 3848",
  transform: "translate(1300 109)",
  fill: "#fff",
  stroke: "#949db2",
  strokeWidth: 1
}, React.createElement("rect", {
  width: 9,
  height: 2,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 8,
  height: 1,
  fill: "none"
})), React.createElement("g", {
  id: "Rectangle_3849",
  "data-name": "Rectangle 3849",
  transform: "translate(1302 113)",
  fill: "#fff",
  stroke: "#949db2",
  strokeWidth: 1
}, React.createElement("rect", {
  width: 5,
  height: 2,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 4,
  height: 1,
  fill: "none"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/filter.334286cc.svg";
export { SvgComponent as ReactComponent };